import React from "react";
import styled from "styled-components";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";

const Figure = styled.figure`
  margin: 28px auto;
  padding: 0;
  max-width: ${(props) => props.$maxWidth || "780px"};
  width: 100%;
`;

const Pair = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const ImageCard = styled.div`
  background: ${(props) => props.$background || "#ffffff"};
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: 640px) {
    padding: 10px;
    border-radius: 8px;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`;

const ImageLink = styled.a`
  display: block;
  line-height: 0;
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
`;

const Label = styled.div`
  margin-top: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.text};
  letter-spacing: 0.5px;

  @media (max-width: 640px) {
    font-size: 12px;
    margin-top: 8px;
  }
`;

const Caption = styled.figcaption`
  margin-top: 12px;
  padding: 0 4px;
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.muted};
  text-align: center;
  font-style: italic;

  a {
    color: ${colors.muted};
    text-decoration: underline;
  }

  @media (max-width: 640px) {
    font-size: 13px;
    text-align: left;
    margin-top: 10px;
    padding: 0;
  }
`;

function ImageCell({ src, alt, href, label, background }) {
  const img = <Img src={src} alt={alt || ""} loading="lazy" />;
  return (
    <ImageCard $background={background}>
      <ImageWrapper>
        {href ? (
          <ImageLink href={href} target="_blank" rel="nofollow noreferrer">
            {img}
          </ImageLink>
        ) : (
          img
        )}
      </ImageWrapper>
      {label && <Label>{label}</Label>}
    </ImageCard>
  );
}

export function GuideImagePair({
  left,
  right,
  caption,
  maxWidth,
}) {
  return (
    <Figure $maxWidth={maxWidth}>
      <Pair>
        <ImageCell {...left} />
        <ImageCell {...right} />
      </Pair>
      {caption && <Caption>{parseMarkdownLinks(caption)}</Caption>}
    </Figure>
  );
}
